module.exports = "<app-navbar></app-navbar>\n<app-map></app-map>\n<app-chat-panel></app-chat-panel>\n"